import { set, keyBy } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { paginationState } from '../../../../helpers/pagination';
import { fetchVisitHistory } from '../../../sagas/report/visit-history/routines';
import {
  resetVisitHistory,
  visitsHistoryOnChangePage,
  visitsHistoryOnChangeOrder
} from '../../../actions/report/visit-history';
import { paginationSuccessHandler } from '../../../../helpers/reducerPaginationHandler';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'visit_on:desc'
};

const fetchManyHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    const { currentPage: page = 1, limit = 20 } = state.pagination;
    const idIncrementor = page * limit - limit;
    const items = response.items.map((each, i) =>
      set('id', i + 1 + idIncrementor, each)
    );
    return {
      ...state,
      all: {
        ...state.all,
        ...keyBy('id', items)
      },
      pagination: paginationSuccessHandler(
        state.pagination,
        set('items', items, response),
        'id'
      )
    };
  },
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const onResetHandler = action => ({
  [action.toString()]: () => initialState
});

const onChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const onChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...fetchManyHandler(fetchVisitHistory),
  ...onResetHandler(resetVisitHistory),
  ...onChangePageHandler(visitsHistoryOnChangePage),
  ...onChangeOrderHandler(visitsHistoryOnChangeOrder)
});
